import * as $runtime from "../runtime.js";
import * as Data$dDate from "../Data.Date/index.js";
import * as Data$dDate$dComponent from "../Data.Date.Component/index.js";
import * as Data$dDateTime from "../Data.DateTime/index.js";
import * as Data$dDateTime$dInstant from "../Data.DateTime.Instant/index.js";
import * as Data$dEither from "../Data.Either/index.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dJSDate from "../Data.JSDate/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dNumber$dFormat from "../Data.Number.Format/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dString$dCodePoints from "../Data.String.CodePoints/index.js";
import * as Data$dString$dCodeUnits from "../Data.String.CodeUnits/index.js";
import * as Data$dTime from "../Data.Time/index.js";
import * as Data$dTime$dDuration from "../Data.Time.Duration/index.js";
import * as Effect$dNow from "../Effect.Now/index.js";
import {parseRawDate, parseRawDateTime, parseRawTime} from "./foreign.js";
const today = () => {
  const a$p = Effect$dNow.now();
  return Data$dDateTime$dInstant.toDateTime(a$p)._1;
};
const parseISOTime = /* #__PURE__ */ parseRawTime(Data$dMaybe.Nothing)(x => Data$dMaybe.applyMaybe.apply(Data$dMaybe.applyMaybe.apply(Data$dMaybe.applyMaybe.apply(x.hour >= 0 && x.hour <= 23
  ? Data$dMaybe.$Maybe("Just", Data$dTime.Time(x.hour))
  : Data$dMaybe.Nothing)(x.minute >= 0 && x.minute <= 59 ? Data$dMaybe.$Maybe("Just", x.minute) : Data$dMaybe.Nothing))(x.second >= 0 && x.second <= 59
  ? Data$dMaybe.$Maybe("Just", x.second)
  : Data$dMaybe.Nothing))(x.millisecond >= 0 && x.millisecond <= 999 ? Data$dMaybe.$Maybe("Just", x.millisecond) : Data$dMaybe.Nothing));
const parseISODateTime = /* #__PURE__ */ parseRawDateTime(Data$dMaybe.Nothing)(x => Data$dMaybe.applyMaybe.apply((() => {
  const $0 = Data$dMaybe.applyMaybe.apply(Data$dMaybe.applyMaybe.apply(x.year >= -271820 && x.year <= 275759
    ? Data$dMaybe.$Maybe("Just", Data$dDate.canonicalDate(x.year))
    : Data$dMaybe.Nothing)(Data$dDate$dComponent.boundedEnumMonth.toEnum(x.month)))(x.day >= 1 && x.day <= 31 ? Data$dMaybe.$Maybe("Just", x.day) : Data$dMaybe.Nothing);
  if ($0.tag === "Just") { return Data$dMaybe.$Maybe("Just", Data$dDateTime.DateTime($0._1)); }
  return Data$dMaybe.Nothing;
})())(Data$dMaybe.applyMaybe.apply(Data$dMaybe.applyMaybe.apply(Data$dMaybe.applyMaybe.apply(x.hour >= 0 && x.hour <= 23
  ? Data$dMaybe.$Maybe("Just", Data$dTime.Time(x.hour))
  : Data$dMaybe.Nothing)(x.minute >= 0 && x.minute <= 59 ? Data$dMaybe.$Maybe("Just", x.minute) : Data$dMaybe.Nothing))(x.second >= 0 && x.second <= 59
  ? Data$dMaybe.$Maybe("Just", x.second)
  : Data$dMaybe.Nothing))(x.millisecond >= 0 && x.millisecond <= 999 ? Data$dMaybe.$Maybe("Just", x.millisecond) : Data$dMaybe.Nothing)));
const parseISODateTimeEither = x => {
  const $0 = parseISODateTime(x);
  if ($0.tag === "Nothing") { return Data$dEither.$Either("Left", "invalid datetime"); }
  if ($0.tag === "Just") { return Data$dEither.$Either("Right", $0._1); }
  $runtime.fail();
};
const parseISODate = /* #__PURE__ */ parseRawDate(Data$dMaybe.Nothing)(x => Data$dMaybe.applyMaybe.apply(Data$dMaybe.applyMaybe.apply(x.year >= -271820 && x.year <= 275759
  ? Data$dMaybe.$Maybe("Just", Data$dDate.canonicalDate(x.year))
  : Data$dMaybe.Nothing)(Data$dDate$dComponent.boundedEnumMonth.toEnum(x.month)))(x.day >= 1 && x.day <= 31 ? Data$dMaybe.$Maybe("Just", x.day) : Data$dMaybe.Nothing));
const padLeft = padLeft$a0$copy => padLeft$a1$copy => padLeft$a2$copy => {
  let padLeft$a0 = padLeft$a0$copy, padLeft$a1 = padLeft$a1$copy, padLeft$a2 = padLeft$a2$copy, padLeft$c = true, padLeft$r;
  while (padLeft$c) {
    const ch = padLeft$a0, n = padLeft$a1, str = padLeft$a2;
    if (Data$dString$dCodePoints.toCodePointArray(str).length < n) {
      padLeft$a0 = ch;
      padLeft$a1 = n;
      padLeft$a2 = Data$dString$dCodeUnits.fromCharArray([ch]) + str;
      continue;
    }
    padLeft$c = false;
    padLeft$r = str;
  }
  return padLeft$r;
};
const midnightInMillisecondsSinceEpoch = date => Data$dDate.diff(Data$dTime$dDuration.durationMilliseconds)(date)(Data$dDate.canonicalDate(1970)((() => {
  const $0 = Data$dDate$dComponent.boundedEnumMonth.toEnum(1);
  if ($0.tag === "Just") { return $0._1; }
  $runtime.fail();
})())(1));
const halfDayInMilliseconds = 43200000.0;
const formatNativeDateTimePicker = date => {
  const $0 = Data$dJSDate.dateMethodEff("getFullYear", date);
  return () => {
    const a$p = $0();
    const a$p$1 = Data$dJSDate.dateMethodEff("getMonth", date)();
    const a$p$2 = Data$dJSDate.dateMethodEff("getDate", date)();
    const a$p$3 = Data$dJSDate.dateMethodEff("getHours", date)();
    const a$p$4 = Data$dJSDate.dateMethodEff("getMinutes", date)();
    return padLeft("0")(4)(Data$dNumber$dFormat.toString(a$p)) + "-" + padLeft("0")(2)(Data$dNumber$dFormat.toString(a$p$1 + 1.0)) + "-" + padLeft("0")(2)(Data$dNumber$dFormat.toString(a$p$2)) + "T" + padLeft("0")(2)(Data$dNumber$dFormat.toString(a$p$3)) + ":" + padLeft("0")(2)(Data$dNumber$dFormat.toString(a$p$4));
  };
};
const formatISOTime = time => padLeft("0")(2)(Data$dShow.showIntImpl(time._1)) + ":" + padLeft("0")(2)(Data$dShow.showIntImpl(time._2)) + ":" + padLeft("0")(2)(Data$dShow.showIntImpl(time._3)) + "." + padLeft("0")(3)(Data$dShow.showIntImpl(time._4));
const formatISODate = date => padLeft("0")(4)(Data$dShow.showIntImpl(date._1)) + "-" + padLeft("0")(2)(Data$dShow.showIntImpl((() => {
  if (date._2.tag === "January") { return 1; }
  if (date._2.tag === "February") { return 2; }
  if (date._2.tag === "March") { return 3; }
  if (date._2.tag === "April") { return 4; }
  if (date._2.tag === "May") { return 5; }
  if (date._2.tag === "June") { return 6; }
  if (date._2.tag === "July") { return 7; }
  if (date._2.tag === "August") { return 8; }
  if (date._2.tag === "September") { return 9; }
  if (date._2.tag === "October") { return 10; }
  if (date._2.tag === "November") { return 11; }
  if (date._2.tag === "December") { return 12; }
  $runtime.fail();
})())) + "-" + padLeft("0")(2)(Data$dShow.showIntImpl(date._3));
const formatISODateTime = v => formatISODate(v._1) + "T" + formatISOTime(v._2) + "Z";
const addDays = days => date => {
  const $0 = Data$dDateTime.adjust(Data$dTime$dDuration.durationDays)(Data$dInt.toNumber(days))(Data$dDateTime.$DateTime(date, Data$dTime.$Time(0, 0, 0, 0)));
  if ($0.tag === "Just") { return $0._1._1; }
  $runtime.fail();
};
export {
  addDays,
  formatISODate,
  formatISODateTime,
  formatISOTime,
  formatNativeDateTimePicker,
  halfDayInMilliseconds,
  midnightInMillisecondsSinceEpoch,
  padLeft,
  parseISODate,
  parseISODateTime,
  parseISODateTimeEither,
  parseISOTime,
  today
};
export * from "./foreign.js";
